import { DigitDisplay } from "./components/DigitDisplay";
import { EngravedText } from "./components/EngravedText";
import { Keypad } from "./components/Keypad";
import { WidgetFrame } from "./components/WidgetFrame";
import { ApartmentStatus, ControlSymbol, IntercomWidgetVariant } from "./const";
import { useIntercomKeypad } from "./hooks/useIntercomKeypad";

export type IntercomWidgetProps = {
  variant: IntercomWidgetVariant;
  maxDigits: number;
  onSubmit: (value: string) => Promise<void>;
  onChange: (value: string) => void;
  submitDelayMs: number;
  apartmentStatus: ApartmentStatus;
};

const variants = {
  [IntercomWidgetVariant.Simple]: {
    digitDisplay: {
      position: {
        top: 31,
        left: 30,
      },
      size: {
        width: 150,
        height: 52,
      },
    },
    keypad: {
      position: {
        top: 102,
      },
    },
  },
  [IntercomWidgetVariant.Modern]: {
    digitDisplay: {
      position: {
        top: 23,
        left: 20,
      },
      size: {
        width: 120,
        height: 52,
      },
    },
    keypad: {
      position: {
        top: 120,
      },
    },
  },
  [IntercomWidgetVariant.Elite]: {
    digitDisplay: {
      position: {
        top: 87,
        left: 78,
      },
      size: {
        width: 122,
        height: 54,
      },
    },
    keypad: {
      position: {
        top: 155,
      },
    },
  },
};

export default function IntercomWidget({
  variant,
  maxDigits,
  onSubmit,
  onChange,
  submitDelayMs,
  apartmentStatus,
}: IntercomWidgetProps) {
  const { value, handleChange } = useIntercomKeypad({
    maxDigits,
    onSubmit,
    onChange,
    submitDelayMs,
  });
  const { digitDisplay, keypad } = variants[variant];

  return (
    <WidgetFrame size="md" variant={variant}>
      <div
        className="absolute"
        style={{ top: digitDisplay.position.top, left: digitDisplay.position.left }}
      >
        <DigitDisplay
          value={value}
          maxDigits={maxDigits}
          status={apartmentStatus}
          size={digitDisplay.size}
        />
      </div>

      <div
        className="absolute left-1/2 -translate-x-1/2 w-full px-8"
        style={{ top: keypad.position.top }}
      >
        <Keypad variant={variant} onButtonClick={handleChange}>
          <Keypad.Row>
            <Keypad.Button symbol="1" />
            <Keypad.Button symbol="2" />
            <Keypad.Button symbol="3" />
          </Keypad.Row>

          <Keypad.Row>
            <Keypad.Button symbol="4" />
            <Keypad.Button symbol="5" />
            <Keypad.Button symbol="6" />
          </Keypad.Row>

          <Keypad.Row>
            <Keypad.Button symbol="7" />
            <Keypad.Button symbol="8" />
            <Keypad.Button symbol="9" />
          </Keypad.Row>

          <Keypad.Row>
            <Keypad.Button symbol={ControlSymbol.SUBMIT} />
            <Keypad.Button symbol="0" />
            <Keypad.Button symbol={ControlSymbol.CLEAR} />
          </Keypad.Row>
        </Keypad>
      </div>

      <EngravedText className="absolute bottom-[32px] left-1/2 -translate-x-1/2 w-full">
        Введите номер квартиры
      </EngravedText>
    </WidgetFrame>
  );
}
